import { Grid } from "@mui/system";
import { LiveCodeBlock } from "../../LiveCodeBlock";
import { RecapCard } from "../../RecapCard";
import VerticalLinearStepper from "../VerticalLinearStepper";
import { Alert, Divider, Typography } from "@mui/material";

export const KdappontCssLesson3 = () => {
  const subjectBlocks = [
    {
      label: "CSS Text",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`h1 {
  color: green;
  text-align: center;
  text-decoration: underline;
  text-transform: uppercase;
}

p.spacing {
  letter-spacing: 5px;
  line-height: 1.8;
}

p.shadow {
  text-shadow: 2px 2px 5px red;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<h1>Hoofdstuk 1</h1>
<p class="spacing">Deze tekst heeft ruimte nodig.</p>
<p class="shadow">Tekst met een schaduw.</p>`}
            />
          </Grid>

          <Grid size={2}>
            <h1
              style={{
                color: "green",
                textAlign: "center",
                textDecoration: "underline",
                textTransform: "uppercase",
                fontSize: "24px",
                marginTop: 0,
              }}
            >
              Hoofdstuk 1
            </h1>
            <p style={{ letterSpacing: "5px", lineHeight: "1.8" }}>
              Deze tekst heeft ruimte nodig.
            </p>
            <p
              style={{
                textShadow: "2px 2px 5px red",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              Tekst met een schaduw.
            </p>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "CSS Fonts",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`/* Fallbacks zijn belangrijk! */
p.serif {
  font-family: "Times New Roman", Times, serif;
}

p.sans {
  font-family: Arial, Helvetica, sans-serif;
}

/* Custom 'Local' Font inladen */
@font-face {
  font-family: 'MijnGaveFont';
  src: url('MijnGaveFont.woff2');
}

p.custom {
  font-family: "MijnGaveFont", Helvetica, sans-serif;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<p class="serif">Dit is een serif font.</p>
<p class="sans">Dit is een sans-serif font.</p>
<p class="custom">Dit is MijnGaveFont font.</p>`}
            />
          </Grid>

          <Grid size={2}>
            <p
              style={{
                fontFamily: '"Times New Roman", Times, serif',
                fontSize: "18px",
              }}
            >
              Dit is een serif font.
              <br />
              <small>(Zie de voetjes aan de letters)</small>
            </p>
            <Divider />
            <p
              style={{
                fontFamily: "Arial, Helvetica, sans-serif",
                fontSize: "18px",
              }}
            >
              Dit is een sans-serif font.
              <br />
              <small>(Strak, zonder voetjes)</small>
            </p>
            <Divider />
            <p
              style={{
                fontSize: "18px",
              }}
            >
              Dit is MijnGaveFont font.
            </p>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "CSS Icons (Font Awesome)",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">

<i class="fa fa-cloud"></i>
<i class="fa fa-heart"></i>
<i class="fa fa-car"></i>`}
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`/* Je kunt icons stylen als tekst! */
i.fa {
  font-size: 24px;
}
.fa-cloud { color: blue; }
.fa-heart { color: red; }`}
              language="css"
            />
          </Grid>

          <Grid size={2}>
            {/* We laden de CSS hier even in voor de preview */}
            <link
              rel="stylesheet"
              href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
            />
            <div style={{ fontSize: "24px", display: "flex", gap: "10px" }}>
              <i className="fa fa-cloud" style={{ color: "blue" }}></i>
              <i className="fa fa-heart" style={{ color: "red" }}></i>
              <i className="fa fa-car"></i>
              <i className="fa fa-file-code-o"></i>
            </div>
            <br />
            <p style={{ fontFamily: "monospace" }}>
              Icons zijn vectoren, dus ze blijven scherp bij elke grootte!
            </p>
          </Grid>
        </Grid>
      ),
    },
    {
      label: "CSS Links",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <LiveCodeBlock
              live={false}
              code={`/* onbezochte link */
a:link {
  color: red;
  text-decoration: none; /* Streep weg */
}

/* muis eroverheen */
a:hover {
  color: hotpink;
  text-decoration: underline;
}

/* geselecteerde link (klik inhouden) */
a:active {
  background-color: yellow;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<a href="#" target="_blank">
  Hover over mij!
</a>`}
            />
          </Grid>

          <Grid size={2}>
            {/* Style tag nodig omdat inline styles geen pseudo-classes (:hover) ondersteunen */}
            <style>
              {`
                .demo-link {
                  color: red;
                  text-decoration: none;
                  font-size: 20px;
                  font-weight: bold;
                  transition: 0.3s;
                }
                .demo-link:hover {
                  color: hotpink;
                  text-decoration: underline;
                  cursor: pointer;
                }
                .demo-link:active {
                  background-color: yellow;
                }
              `}
            </style>

            <div style={{ padding: "20px", textAlign: "center" }}>
              <a href="#!" className="demo-link">
                Hover over mij!
              </a>
            </div>
          </Grid>
        </Grid>
      ),
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "👨🏼‍🏫 Voor vandaag",
          description: `Text Styling | Fonts | Icons | Links`,
          content: (
            <Grid container columns={1} spacing={2}>
              {subjectBlocks.map((subject, index) => (
                <Grid key={index} size={1} sx={{ "& > *": { height: "100%" } }}>
                  <RecapCard subject={subject} />
                </Grid>
              ))}
            </Grid>
          ),
        },
        {
          label: "🚀 Aan de slag!",
          description: `Digitaal lesmateriaal ➡️ KD Appont ➡️ Module 2 :: CSS ➡️ LES 3`,
          content: (
            <Alert severity="error" sx={{ alignItems: "center" }}>
              <Typography variant="h5">
                Maak uiteraard eerst je oefeningen van Les 2 af - of herhaal ze.
                Vergeet ook niet de W3School quizes.
              </Typography>
            </Alert>
          ),
        },
      ]}
    />
  );
};
